import { Info } from "@mui/icons-material";
import { Tooltip, Typography, List, ListItem } from "@mui/material";
import React from "react";

const IntellexusDateTooltip: React.FC = () => {
  return (
    <Tooltip
      arrow
      title={
        <>
          <Typography variant="subtitle2" gutterBottom>
            <strong>How to fill in "From" and "To" fields:</strong>
          </Typography>
          <List dense sx={{ pl: 2 }}>
            <ListItem disableGutters sx={{ display: "list-item", pl: 2 }}>
              <Typography variant="body2">
                <strong>Exact Date:</strong> Enter the same date in both fields.
                Example: <code>27/11/1999</code> in both "From" and "To".
              </Typography>
            </ListItem>
            <ListItem disableGutters sx={{ display: "list-item", pl: 2 }}>
              <Typography variant="body2">
                <strong>Year Range:</strong> Use two different years to indicate
                a time span. Example: <code>1990</code> in "From" and{" "}
                <code>1999</code> in "To".
              </Typography>
            </ListItem>
            <ListItem disableGutters sx={{ display: "list-item", pl: 2 }}>
              <Typography variant="body2">
                <strong>Not Before:</strong> If you only know the earliest
                possible date, leave "To" empty. Example: <code>1990</code> in
                "From" and leave "To" blank.
              </Typography>
            </ListItem>
            <ListItem disableGutters sx={{ display: "list-item", pl: 2 }}>
              <Typography variant="body2">
                <strong>Not After:</strong> If you only know the latest possible
                date, leave "From" empty. Example: leave "From" blank and put{" "}
                <code>1999</code> in "To".
              </Typography>
            </ListItem>
            <ListItem disableGutters sx={{ display: "list-item", pl: 2 }}>
              <Typography variant="body2">
                <strong>Uncertain Dates:</strong> Add a "?" at the end to
                indicate uncertainty. Example: <code>1999?</code> or{" "}
                <code>27/11/1999?</code>.
              </Typography>
            </ListItem>
            <ListItem disableGutters sx={{ display: "list-item", pl: 2 }}>
              <Typography variant="body2">
                <strong>Alternative Years:</strong> Use a slash ("/") to
                indicate two possible years (no more than two). Example:{" "}
                <code>1990/1991</code> is valid, but <code>1990/1991/1992</code>{" "}
                is not allowed.
              </Typography>
            </ListItem>
          </List>
        </>
      }
    >
      <Info color="primary" sx={{ cursor: "pointer" }} />
    </Tooltip>
  );
};

export default IntellexusDateTooltip;
